export const resetV201RequestOptions = ['Immediate', 'OnIdle'] as const;
export type ResetV201RequestOption = (typeof resetV201RequestOptions)[number];
